import React, { useRef } from "react"
import Edges from "../Edges"
import Slider, { Settings } from "react-slick"
import ArrowRight from "../../icons/ArrowRight.svg"
import ArrowLeft from "../../icons/ArrowLeft.svg"

interface ICarouselProps {
  sliderSettings?: Settings
  arrowColor?: string
  checkLength?: number
  minImages: number
}

export const Carousel: React.FC<ICarouselProps> = ({
  arrowColor,
  sliderSettings,
  children,
  checkLength,
  minImages,
}) => {
  const sliderConfig = {
    arrows: false,
    dots: false,
    infinite: checkLength <= (minImages ? minImages : 1) ? false : true,
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,

    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
    ...sliderSettings,
  }

  const sliderRef = useRef<Slider>(null)

  const nextSlide = () => {
    sliderRef.current && sliderRef.current.slickNext()
  }
  const prevSlide = () => {
    sliderRef.current && sliderRef.current.slickPrev()
  }

  return (
    <Edges size="xl">
      <div className="relative flex w-full flex-row items-center justify-center">
        <div className="absolute left-5 flex xl:left-[-75px]">
          <ArrowLeft
            onClick={prevSlide}
            className="cursor-pointer"
            fill={arrowColor || "#FED844"}
          />
        </div>

        <div className="w-[80%] xl:w-full">
          <Slider {...sliderConfig} ref={sliderRef}>
            {children}
          </Slider>
        </div>

        <div className="absolute right-5 flex xl:right-[-75px]">
          <ArrowRight
            onClick={nextSlide}
            className="cursor-pointer"
            fill={arrowColor || "#FED844"}
          />
        </div>
      </div>
    </Edges>
  )
}

export default Carousel
